export default __webpack_public_path__ + "static/in-f687b71a98d12cb3589cd2d3d72551c2.svg";